
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import tabs from '@/views/dashboard/config/drawerTabs';
import { isUnusedDrawerGroup } from '@/components/core/drawerUnused';
import { Drawer } from '@/views/interfaces/vuetify/drawer.interface';
import { Item } from '@/views/interfaces/vuetify/item.interface';

@Component({
  computed: {
    ...mapState({
      barColor: (state: any) => state.bar.barColor,
      barImage: (state: any) => state.bar.barImage,
    }),
  },
})
export default class DashboardCoreDrawer extends Vue {
  private items: Drawer[] = tabs();

  get drawer(): boolean {
    return this.$store.state.drawer.visible;
  }

  set drawer(val: boolean) {
    this.$store.commit('SET_DRAWER', val);
  }

  get mini(): boolean {
    return this.$store.state.drawer.mini;
  }

  get hideUnused(): boolean {
    return this.$store.state.drawer.hideUnused;
  }

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get effectiveMini(): boolean {
    return !this.isMobile && this.mini;
  }

  get computedItems(): any[] {
    const source = this.hideUnused
      ? this.items.filter((item) => !isUnusedDrawerGroup(item.group))
      : this.items;
    return source.map(this.mapItem);
  }

  get isDrawerDark(): boolean {
    return this.barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)';
  }

  public created(): void {
    this.syncDrawerForBreakpoint(this.isMobile);
  }

  @Watch('$vuetify.breakpoint.smAndDown')
  private onBreakpointChange(isMobile: boolean): void {
    this.syncDrawerForBreakpoint(isMobile);
  }

  private syncDrawerForBreakpoint(isMobile: boolean): void {
    if (isMobile) {
      this.$store.commit('SET_DRAWER', false);
    } else if (!this.$store.state.drawer.visible) {
      this.$store.commit('SET_DRAWER', true);
    }
  }

  private toggleMini(): void {
    this.$store.commit('TOGGLE_DRAWER_MINI');
  }

  private setHideUnused(value: boolean): void {
    this.$store.commit('SET_DRAWER_HIDE_UNUSED', !!value);
  }

  private mapItem(item: any): Item {
    return {
      ...item,
      children: item.children ? item.children.map(this.mapItem) : undefined,
      title: this.$t(item.title),
    };
  }
}
